import { Controller, FormProvider, useForm } from "react-hook-form";
import React from "react";
import { FormGroup, SubmitButton } from "../../../../@coherent/react-hook-form";
import { TextQuestion } from "../../components/TextQuestion";
import { Button } from "reactstrap";
import { isEmail } from "validator";

export const Step2aForm = ({ required = true }) => {
  return (
    <>
      <h3 className="tw-text-lg mb-4">Parental/Guardian details</h3>
      <p>
        Please provide us with the name and contact details for a
        parent/guardian who can confirm that they give their permission for you
        to volunteer at Make Lunch. We will email them with a consent form to
        complete so please make sure you have let them know that you are
        applying to volunteer before completing this section:
      </p>
      <TextQuestion
        required={required}
        name="parent_guardian_first_name"
        label="Parent/Guardian First Name"
      />
      <TextQuestion
        required={required}
        name="parent_guardian_last_name"
        label="Parent/Guardian Last Name"
      />
      <FormGroup
        label="Relationship"
        required={required}
        name="parent_guardian_relationship"
      >
        <Controller
          rules={{
            required,
          }}
          name="parent_guardian_relationship"
          defaultValue=""
          render={(field) => (
            <select className="form-control" {...field}>
              <option disabled value=""></option>
              <option value="Parent">Parent</option>
              <option value="Other">Other Legal Guardian</option>
            </select>
          )}
        />
      </FormGroup>
      <TextQuestion
        required={required}
        type="email"
        validate={(v) => !required || isEmail(v)}
        name="parent_guardian_email"
        label="Parent/Guardian Email Address"
      />
      <TextQuestion
        required={required}
        name="parent_guardian_phone_number"
        label="Parent/Guardian Phone Number"
      />
    </>
  );
};

export const Step2a = ({ onSubmit, defaultValues, onBack }) => {
  const methods = useForm({
    mode: "onBlur",
    defaultValues,
    shouldUnregister: true,
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Step2aForm />
        <div className="tw-flex tw-justify-between">
          <Button onClick={onBack}>Back</Button>
          <SubmitButton>Continue</SubmitButton>
        </div>
      </form>
    </FormProvider>
  );
};
